export default {"src":"/_next/static/media/well-done.colour.3d167c1e.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};